import { matchPath } from 'react-router-dom'

interface MenuRoute {
  path: string
  exact?: boolean
  strict?: boolean
  name: string
  menu: string
}

// NOTE: keep up-to-date with available routes
const routes: MenuRoute[] = [
  {
    path: '/login',
    exact: true,
    name: 'login',
    menu: 'login',
  },
  {
    path: '/profile',
    exact: true,
    name: 'profile',
    menu: 'profile',
  },
  {
    path: '/trips',
    exact: true,
    name: 'trips_list',
    menu: 'trips',
  },
  {
    path: '/trips/:tripCid',
    exact: true,
    name: 'trip_details',
    menu: 'trips',
  },
  {
    path: '/drivers',
    exact: true,
    name: 'drivers_list',
    menu: 'drivers',
  },
  {
    path: '/vehicles',
    exact: true,
    name: 'vehicles_list',
    menu: 'vehicles',
  },
  {
    path: '/quotes',
    exact: true,
    name: 'quotes_list',
    menu: 'quotes',
  },
  {
    path: '/quotes/:token',
    exact: true,
    name: 'quote_details',
    menu: 'quotes',
  },
  {
    path: '/wl/:jwt',
    exact: true,
    name: 'weblink',
    menu: 'weblink',
  },
  {
    path: '/ql/:token',
    exact: true,
    name: 'quotelink',
    menu: 'quotelink',
  },
  {
    path: '/deca/:token',
    exact: true,
    name: 'deca',
    menu: 'deca',
  },
  {
    path: '/users',
    exact: true,
    name: 'users_list',
    menu: 'users',
  },
  {
    path: '/companies',
    exact: true,
    name: 'companies_list',
    menu: 'companies',
  },
  {
    path: '/carriers',
    exact: true,
    name: 'carriers_list',
    menu: 'carriers',
  },
  {
    path: '/carrier-profile',
    exact: true,
    name: 'carrier-profile',
    menu: 'carrier-profile',
  },
  {
    path: '/help-and-info',
    exact: true,
    name: 'help-and-info',
    menu: 'help-and-info',
  },
  {
    path: '/rejected-messages',
    exact: true,
    name: 'rejected-messages',
    menu: 'rejected-messages',
  },
]

export const getActiveRoute = (location: string): MenuRoute | undefined =>
  routes.find(
    (route) =>
      matchPath(location, {
        path: route.path,
        exact: route.exact ?? false,
        strict: route.strict ?? false,
      }) !== null,
  )

export const getRouteName = (location: string): string => {
  const activeRoute = getActiveRoute(location)
  return activeRoute?.name ?? 'unknown'
}

export const getActiveMenu = (location: string): string | null => {
  const activeRoute = getActiveRoute(location)
  return activeRoute?.menu ?? null
}
